<div class="card">
  <div class="card-header title" id="{{ id }}">
    <a
      (click)="idChild.toggle()"
      class="btn btn-link"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="puntodeventacollapse"
    >
      <img
        src="assets/img/{{ icon }}"
        alt="{{ label | translate }}"
        class="mr-2"
      />{{ label | translate }}
    </a>
  </div>
  <div #idChild="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <ng-content></ng-content>
  </div>
</div>
